var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDownWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.64592 5.14599C1.69236 5.09943 1.74754 5.06249 1.80828 5.03728C1.86903 5.01207 1.93415 4.9991 1.99992 4.9991C2.06568 4.9991 2.13081 5.01207 2.19155 5.03728C2.2523 5.06249 2.30747 5.09943 2.35392 5.14599L7.99992 10.793L13.6459 5.14599C13.6924 5.09951 13.7476 5.06263 13.8083 5.03747C13.8691 5.01231 13.9342 4.99936 13.9999 4.99936C14.0657 4.99936 14.1308 5.01231 14.1915 5.03747C14.2522 5.06263 14.3074 5.09951 14.3539 5.14599C14.4004 5.19248 14.4373 5.24767 14.4624 5.30841C14.4876 5.36915 14.5005 5.43425 14.5005 5.49999C14.5005 5.56574 14.4876 5.63084 14.4624 5.69158C14.4373 5.75232 14.4004 5.80751 14.3539 5.85399L8.35392 11.854C8.30747 11.9006 8.2523 11.9375 8.19155 11.9627C8.13081 11.9879 8.06568 12.0009 7.99992 12.0009C7.93415 12.0009 7.86903 11.9879 7.80828 11.9627C7.74754 11.9375 7.69236 11.9006 7.64592 11.854L1.64592 5.85399C1.59935 5.80755 1.56241 5.75237 1.5372 5.69163C1.512 5.63088 1.49902 5.56576 1.49902 5.49999C1.49902 5.43423 1.512 5.3691 1.5372 5.30836C1.56241 5.24761 1.59935 5.19244 1.64592 5.14599Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownWhite);
export default __webpack_public_path__ + "static/media/arrow-down-white.4ea6f79f27e743e3fa5211bea654b811.svg";
export { ForwardRef as ReactComponent };